// @ts-nocheck
import { NgClass, NgStyle, NgTemplateOutlet } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
  forwardRef,
} from '@angular/core';
import { IconComponent } from '@lbca-shared/icon';
import { DynamicFormService } from '../dynamic-form/dynamic-form.service';
import { FileUploadComponent } from '../dynamic-form/sub-modules/file-upload/file-upload.component';
import { EntityFieldsComponent } from '../dynamic-form/sub-modules/sub-form/entity-fields/entity-fields.component';
import { AdditionalValuesCondensedComponent } from '../fields/additional-values-condensed/additional-values-condensed.component';
import { DatePickerCondensedComponent } from '../fields/date-picker-condensed/date-picker-condensed.component';
import { DateTimePickerCondensedComponent } from '../fields/date-time-picker-condensed/date-time-picker-condensed.component';
import { FileFromProcessComponent } from '../fields/file-from-process/file-from-process.component';
import { GridboxComponent } from '../fields/gridbox/gridbox.component';
import { InputHiddenComponent } from '../fields/input-hidden/input-hidden.component';
import { InputTextCondensedComponent } from '../fields/input-text-condensed/input-text-condensed.component';
import { SelectTreeCondensedComponent } from '../fields/select-tree-condensed/select-tree-condensed.component';
import { TableListComponent } from '../fields/table-list/table-list.component';
import { TextareaCondensedComponent } from '../fields/textarea-condensed/textarea-condensed.component';
import { TimepickerCondensedComponent } from '../fields/timepicker-condensed/timepicker-condensed.component';
import { ClickTableOutsideDirective, TableDirective } from '../table/table.directive';
import { Table, TopSticky } from '../table/table.model';

@Component({
  selector: 'lbca-table-condensed',
  templateUrl: './table-condensed.component.html',
  styleUrl: './table-condensed.component.scss',
  imports: [
    NgClass,
    TableDirective,
    NgTemplateOutlet,
    NgStyle,
    ClickTableOutsideDirective,
    InputHiddenComponent,
    forwardRef(() => InputTextCondensedComponent),
    forwardRef(() => DateTimePickerCondensedComponent),
    forwardRef(() => DatePickerCondensedComponent),
    forwardRef(() => TimepickerCondensedComponent),
    forwardRef(() => EntityFieldsComponent),
    forwardRef(() => GridboxComponent),
    forwardRef(() => AdditionalValuesCondensedComponent),
    forwardRef(() => TextareaCondensedComponent),
    forwardRef(() => TableListComponent),
    forwardRef(() => SelectTreeCondensedComponent),
    forwardRef(() => FileUploadComponent),
    IconComponent,
    forwardRef(() => FileFromProcessComponent),
  ],
})
export class TableCondensedComponent implements OnChanges {
  public isDisabled = false;

  public dynamicFormService!: DynamicFormService;
  public gridFormModuleInstance: any;

  @Input('gridFormModuleInstance') set gridFormModuleInstanceController(fn) {
    this.gridFormModuleInstance = fn;
  }
  @Input('dynamicFormService') set formServiceSetter(dynamicFormService: DynamicFormService) {
    this.dynamicFormService = dynamicFormService;
  }

  @Input() highlight = false;
  @Input() saveOnChange = false;

  @Input() table: Table = {
    body: [],
  };
  @Input('columns') set tableColumnsSetter(value: any) {
    if (value) {
      this.table.columns = value;

      this.total = 0;
      this.table?.columns?.forEach((col) => {
        this.total += col.col;
      });

      const name = this.getDefaultOrder();
      if (!name) return;
      this.orderTable(name, 'ASC');
    }
  }

  @Input('details') set tableDetailsSetter(value: any) {
    this.table.details = value;
  }
  @Input('body') set tableBodySetter(value: any) {
    this.table.body = value;
  }
  @Input('config') set tableConfigSetter(value: any) {
    this.table.config = value;
  }

  @Input() fixedTop!: TopSticky;
  @Input() lineCickable = true;
  @Input() paginationType: 'next' | 'prev' | 'choose' | 'none' = 'next';
  @Input() totalPagesValue = 0;

  @Input()
  set removeLine(line) {
    if (!line) return;
    this.lineRemove.push(line);
  }

  @Input() set disabled(disabled) {
    this.isDisabled = disabled;
  }

  @Input()
  set rightDeslocation(line) {
    if (!line) return;

    const check = this.goRight.some((check) => check.id === line.id);

    if (!check) {
      this.goRight.push(line);
    } else {
      this.goRight = this.goRight.filter((item) => item.id !== line.id);
    }
  }

  public cardInfo!: any;
  @Input()
  set cardData(data: any) {
    this.cardInfo = data;
  }

  public dataAttr!: any;
  @Input('dataAttr') set data(data) {
    this.dataAttr = data;
  }

  @Output() order = new EventEmitter();
  @Output() clickLine = new EventEmitter();

  @Output('changeValue') changeEmmiter = new EventEmitter();

  @ViewChild('itemList', { static: false }) itemList!: ElementRef;
  @ViewChild('inputValue', { static: false }) inputValue!: ElementRef;
  @ViewChild('inputValueAsc', { static: false }) inputValueAsc!: ElementRef;
  @Output('saveChanges') saveEmmiter = new EventEmitter();

  private typingTimer;

  private total!: any;

  private goRight: any = [];
  private lineRemove: any = [];

  checkLineDeslocation(lane) {
    return this.goRight.some((check) => check.id === lane.id);
  }

  checkLineRemove(lane) {
    return this.lineRemove.some((check) => check.id === lane.id);
  }

  getPercents(col) {
    const percent = Math.round((col / this.total) * 100);
    return `${percent}%`;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['table']) {
      this.table = changes['table'].currentValue;
    }
  }

  public clickTableLine(line) {
    if (this.lineCickable) this.clickLine.emit(line);
  }

  public orderTableEvent($event, name, value) {
    $event.stopPropagation();
    this.orderTable(name, value);
  }

  private orderTable(name, value) {
    let directionOrder = 'ASC';
    if (value.checked) {
      directionOrder = 'DESC';
    }
    const orderReponse = {
      directionOrder,
      propertyOrder: name,
    };

    this.order.emit(orderReponse);
  }

  public getHeadCss(col) {
    return col?.cssHeader;
  }

  public stopPropagation($event) {
    $event.stopPropagation();
  }

  public openSearch(self, inputSearch) {
    if (self.checked) {
      inputSearch.focus();
    }
  }

  private getDefaultOrder() {
    const defaultColumn = this.table?.columns?.find((col) => col.orderDefault === true);
    return defaultColumn ? defaultColumn.name : null;
  }

  private sendSerach(value) {
    this.order.emit({
      searchCriteria: value,
    });
  }

  changeValue(val: any, obj: any, lane, entityKey) {
    const montaObj = obj;
    montaObj.value = val;
    this.changeEmmiter.emit({ lane, montaObj, entityKey });
    if (this.saveOnChange) this.saveEmmiter.emit({ lane, montaObj });
  }

  public searchString(inputSearch) {
    clearTimeout(this.typingTimer);
    this.typingTimer = setTimeout(() => this.sendSerach(inputSearch.value), 300);
  }
}
